"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getName = exports.getBuyer = void 0;
const tender_box_1 = require("../../schema/matching/tender-box");
function getBuyer(general) {
    var _a, _b, _c, _d;
    const field = (_c = (_b = (_a = general.buyerBoxes) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.fields) === null || _c === void 0 ? void 0 : _c[0];
    return (field === null || field === void 0 ? void 0 : field.type) === tender_box_1.ProcurementBoxFieldType.String ? (_d = field === null || field === void 0 ? void 0 : field.string) !== null && _d !== void 0 ? _d : undefined : undefined;
}
exports.getBuyer = getBuyer;
function getName(general) {
    var _a, _b;
    const field = (_a = general.name) === null || _a === void 0 ? void 0 : _a.fields[0];
    return (field === null || field === void 0 ? void 0 : field.type) === tender_box_1.ProcurementBoxFieldType.String ? (_b = field === null || field === void 0 ? void 0 : field.string) !== null && _b !== void 0 ? _b : undefined : undefined;
}
exports.getName = getName;
